import React from 'react';
import { CommunicationHub as CommunicationHubComponent } from '@/components/communications/CommunicationHub';

export default function CommunicationHub() {
  return (
    <div className="p-6">
      <CommunicationHubComponent />
    </div>
  );
}